import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import { TextField } from '@mui/material'

const HSDetails = () => {
  const { formValues, handleChange } = useContext(EPCRContext)

  return (
      <TextField
        label="Details"
        value={formValues?.incident?.healthSafetyDetails}
        size='small'
        multiline
        minRows={2}
        onChange={(e) =>
          handleChange({
            moduleName: 'incident',
            field: 'healthSafetyDetails',
            value: e.target.value,
          })
        }
        helperText="What are the details about the health and safety concern? Do not include patient identifiable information here."
      />
  )
}

export default HSDetails